/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useApi } from '@micromag/data';

import * as AppPropTypes from '../lib/PropTypes';
import { useUser } from './AuthContext';

const OrganisationContext = React.createContext(null);

export const useOrganisation = () => {
    const { organisation } = useContext(OrganisationContext);
    return organisation;
};
export const useSetOrganisation = () => {
    const { setOrganisation } = useContext(OrganisationContext);
    return setOrganisation;
};

const propTypes = {
    children: PropTypes.node.isRequired,
    organisation: AppPropTypes.organisation,
};

const defaultProps = {
    organisation: null,
};

export const OrganisationProvider = ({ organisation: initialOrganisation, children }) => {
    const [organisation, setOrganisation] = useState(initialOrganisation);

    const api = useApi();
    const user = useUser();
    const lastUserRef = useRef(user);

    useEffect(() => {
        if (initialOrganisation !== organisation) {
            setOrganisation(initialOrganisation);
        }
    }, [initialOrganisation]);

    useEffect(() => {
        if (user !== null && lastUserRef.current !== user && organisation !== null) {
            lastUserRef.current = user;
            api.organisations.find(organisation.id).then(setOrganisation);
        }
    }, [user, api]);

    const value = useMemo(
        () => ({ organisation, setOrganisation }),
        [organisation, setOrganisation],
    );

    return <OrganisationContext.Provider value={value}>{children}</OrganisationContext.Provider>;
};

OrganisationProvider.propTypes = propTypes;
OrganisationProvider.defaultProps = defaultProps;

export default OrganisationContext;
